/*
 * Copyright (c) 2019 brightlamp
 */

import Vue from 'vue'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
    iconfont: 'mdi',
    dark: false,
    theme:
    {
        themes:
        {
            light:
            {
                primary: colors.shades.black,
                secondary: colors.shades.white,
                accent: "#fffd00",
                anchor: colors.shades.black
            }
        }
    }
})
